import regularUrl from '@fontsource/inter/files/inter-latin-400-normal.woff?url';
import boldUrl from '@fontsource/inter/files/inter-latin-600-normal.woff?url';

export interface QuoteFonts {
  regular: Uint8Array;
  bold: Uint8Array;
}

let cached: Promise<QuoteFonts> | null = null;

/** Inter Regular + SemiBold (WOFF) for the quote PDF, fetched once (precached by the PWA). */
export function loadQuoteFonts(): Promise<QuoteFonts> {
  cached ??= Promise.all(
    [regularUrl, boldUrl].map(async (u) => new Uint8Array(await (await fetch(u)).arrayBuffer())),
  ).then(([regular, bold]) => ({ regular, bold }));
  return cached;
}
